import React from "react";

const Scoring = () => {
  return (
    <>
      <div className="scoring">
        <div className="wrapper">
          <div className="heading content">
            <div
              className="sub-title"
              data-reveal="bottom"
              style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
            >
              Community scoring
            </div>
            <h2
              className="h1"
              data-reveal="bottom"
              style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
            >
              <small>
                Community <strong>Sentiment Analysis</strong> combining
              </small>{" "}
              Real-Time Insights with AI
            </h2>
            <div
              className="intro"
              data-reveal="bottom"
              style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
            >
              <p>
                Explore the core of crypto communities with our AI analysis. We
                look at the most recent messages from each project's channels to
                understand true feelings. This way, we can tell real excitement
                from simple airdrop waiting. With this insight, plus a score
                based on social media activities, you get to know the real vibe
                and quality of the community.
              </p>
            </div>
            <div
              className="btn-group"
              data-reveal="bottom"
              style={{translate: "none", rotate: "none", scale: "none", transform: "translate(0px)", opacity: "1", visibility: "inherit"}}
            >
              <a className="btn" data-colors="primary" href="/portal">
                <span className="btn-txt">Launch App</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--carbon"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M16.001 26.473H16L4.284 12.955L9.5 6h13l5.216 6.955l-3.24 3.737l1.513 1.31l4.295-4.957L23.5 4h-15l-6.784 9.045l12.772 14.737z"
                  ></path>
                  <path fill="currentColor" d="m20 19l7 5l-7 5z"></path>
                </svg>
                <div className="corner" data-colors="primary">
                  <span className="corner-left"></span>
                  <span className="corner-right"></span>
                  <span className="corner-top-bottom"></span>
                </div>
              </a>
            </div>
            <div className="point"></div>
          </div>
          <div className="arrow">
            <div className="lazyload-wrapper ">
              <picture>
                <img
                  src="/assets/arrow-J89WC9rP.png"
                  width="884"
                  height="664"
                  alt="Arrow Scoring"
                  draggable="false"
                  loading="lazy"
                />
              </picture>
            </div>
            <div className="point"></div>
          </div>
          <div className="lazyload-wrapper ">
            <picture className="bck">
              <img
                src="/assets/bg-sentiment-nCmXV7uO.png"
                width="1800"
                height="1064"
                alt="Scoring"
                draggable="false"
                loading="lazy"
              />
            </picture>
          </div>
        </div>
      </div>
    </>
  );
};

export default Scoring;
